<div id="services-popup" class="common-popup-block-doc actuaciones-pop">
    <div class="popoup-hearder">
        <h2 class="m-b-5" mat-dialog-title>Fecha facturación de médicos</h2>
    </div>
    <form class="add-document-form" [formGroup]="cerrarfacturacionFormGroup" role="form">
        <div class="popoup-content">
            <div class="block-looper-wrapper">
                <div class="block-looper">
                    <div class="form-wrap form-wrap-half">
                        <input matInput [matDatepicker]="picker" formControlName="Date">
                        <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
                        <mat-datepicker #picker></mat-datepicker>
                    </div>
                     <mat-error class="m-t--15" *ngIf="cerrarfacturacionFormGroup.get('Date').dirty && cerrarfacturacionFormGroup.get('Date').invalid">
                        <span class="validation-span font-88">Obligatorio</span>
                    </mat-error>
                </div>
            </div>
        </div>
    </form>

    <div class="popoup-footer">
        <button class="keep" (click)="cerrarfacturacion()"><span class="mat-button-wrapper">Guardar</span></button>
        <button class="cancel" (click)="cancel()"><span class="mat-button-wrapper">Cancelar</span></button>
    </div>
</div>

